/**
 * Determine if a feature is currently restricted for the signed-in user due
 * to pending / expired COPPA parental consent.
 *
 * Server sets `user.consent_status` to one of:
 *   "pending"     , within 72h grace (full access, banner shown)
 *   "expired"     , past 72h without parent consent (gated features)
 *   "not_required", child is 13+
 *   "approved"    , parent clicked confirm email
 *
 * Features currently gated after grace expires:
 *   - ai_tutor         (AI chat, COPPA data-handling concern)
 *   - family_games     (social multiplayer)
 *   - marketplace      (purchases / real-money flows)
 *   - adventures       (multiplayer worlds)
 *
 * Always allowed even when gated:
 *   - learn, arcade (solo learning), art-studio (solo), profile, progress
 */
export const GATED_FEATURES = new Set([
  "ai_tutor",
  "family_games",
  "marketplace",
  "adventures",
]);

export function isFeatureGated(user, featureKey) {
  if (!user) return false;
  if (user.role !== "child_explorer") return false;
  if (user.consent_status !== "expired") return false;
  return GATED_FEATURES.has(featureKey);
}

export function consentGateCopy() {
  return "This feature is paused until a grown-up clicks the confirm link in their email.";
}
